import {z} from 'zod';

export const PrintOnDemandRequestSchema = z.object({
  body: z.object({
    docOriginId: z.string(),
    originEntityPrintoutType: z.union([
      z.literal('prntReceiveNote'),
      z.literal('prntCreditNote'),
      z.literal('prntSupplierOrder'),
      z.literal('prntIssueNoteCorrection'),
      z.literal('prntDirectSaleOffer'),
      z.literal('prntIssueNoteCostCorrection'),
      z.literal('prntServiceOrderIssueNote'),
      z.literal('prntServiceOrderReturn'),
      z.literal('prntFastTrack'),
      z.literal('prntIssueNote'),
      z.literal('prntTransferOrder'),
    ]),
  }),
});

export type PrintOnDemandRequest = z.infer<typeof PrintOnDemandRequestSchema>;

export const PrintOnDemandResponseSchema = z
  .object({
    printout: z
      .object({
        url: z.string().nullable().optional(),
        pdfUrl: z.string().nullable().optional(),
        fileId: z.string().nullable().optional(),
        remoteFileId: z.string().nullable().optional(),
      })
      .nullable()
      .optional(),
  })
  .nullable();

export type PrintOnDemandResponse = z.infer<typeof PrintOnDemandResponseSchema>;
